/**
 * Copy for the purchase timeline — "how your free trial works".
 *
 * Only the fixed wording lives here. Every DATE and every AMOUNT it renders
 * comes from the server's disclosure, because each is a promise: the trial
 * length and first-charge date are the provider's, and the reminder row is shown
 * only when that email will genuinely be sent.
 */
export enum PurchaseTimelineMessage {
  Today = 'Today',
  DayPrefix = 'Day',
  /** Reminder row, counted BACK from the first charge — "3 days before" is what
   *  the buyer needs to know (how much warning they get), whereas "Day 11" makes
   *  them subtract. The number comes from the server's reminder date, never a
   *  fixed offset here. */
  DaysBeforeSuffix = 'days before',
  DayBeforeSuffix = 'day before',
  TodayTitle = 'Everything unlocks',
  TodayDetail = 'Full access to cloud backup, sync and protected sharing.',
  ReminderTitle = 'We email you a reminder',
  ReminderDetail = 'A heads-up that your free trial is ending soon.',
  ChargeTitle = 'Your first charge',
  CancelBefore = 'Cancel any time before then and you pay nothing.',
  /** Lead-in above the plan list. Deliberately does not quote a price: the plan
   *  cards below it do, and they can still be changed. */
  TrialLeadInPrefix = 'First',
  TrialLeadInSingular = 'day is free, then as per your plan',
  TrialLeadInPlural = 'days are free, then as per your plan',
  /** The step CTA — deliberately not "Subscribe": nothing is charged yet. */
  Continue = 'Continue',
  StartTrial = 'Start my free trial now',
  /** Reassurance under the trial CTA. */
  TrialFootnote = 'Starts in a few taps, cancel anytime.',
  Back = 'Back',
}
